<template>
    <div v-if="UserLogueado()" class="ContenedorGUI">
        <div class="ContenedorHeader">
            <!-- <router-link :to="-1"> -->
            <font-awesome-icon
                @click="GoBack()"
                icon="arrow-left"
                size="4x"
                :style="{ color: 'white' }"
                class="IconoHeader1 fLeft vAliMid"
            />
            <!-- </router-link> -->
            <router-link to="/">
                <img
                    src="../assets/logo-agroideas.png"
                    alt="LogoAgroideas"
                    class="LogoAgroideas vAliMid"
                />
            </router-link>
            <!-- <img v-on:click="ClickAnterior()" src="../assets/Back.png" alt="Back" class="IconoHeader fLeft vAliMid" v-show="!this.$parent.Datos.PantallaPrincipal()"> -->
            <font-awesome-icon
                v-on:click="ClickMenu()"
                icon="bars"
                size="4x"
                :style="{ color: 'white' }"
                class="IconoHeader fRight vAliMid"
            />
            <!-- <font-awesome-icon icon="user-tie" size="4x" :style="{ color: 'white'}"  class="IconoHeader fRight vAliMid"/> -->
            <div class="clear"></div>
            <!-- <img src="../assets/logo-maiz-plus.png" alt="LogoMaizPlus" class="LogoAgroideas fRight"> -->
        </div>

        <div class="Menu" ref="Menu">
            <div class="w100 aliLeft pR">
                <font-awesome-icon
                    v-on:click="ClickMenu()"
                    icon="times"
                    size="4x"
                    :style="{ color: 'white' }"
                    class="IconoHeader IconoCerrarMenu fRight vAliMid"
                />
                <GUILink icon="user-tie" tiene-borde-inferior
                    >Hola <span ref="NombreUsuario">{{ NombreUsuario() }}</span
                    >!</GUILink
                >
                <GUILink
                    route="/productores"
                    icon="users"
                    seccion="Productores"
                    v-on:click.native="ClickMenu()"
                    v-show="this.SeccionProductoresVisible"
                    tiene-borde-inferior
                    >Productores</GUILink
                >

                <div id="herramientas">
                    <GUILink
                        v-for="herr in Herramientas.GetValues()"
                        :key="herr.id"
                        :route="herr.path"
                        :icon="herr.icon"
                        v-on:click.native="ClickMenu()"
                    >
                        {{
                            herr.title
                                ? herr.title.substring(0, 22) + "..."
                                : ""
                        }}
                    </GUILink>
                </div>

                <div v-on:click="Desloguear()">
                    <GUILink icon="sign-out-alt" tiene-borde-superior
                        >Salir</GUILink
                    >
                </div>
            </div>
        </div>

        <div :class="FooterClass()">
            <div ref="DivSinConexion" class="DivSinConexion">Sin conexión</div>
            <div class="aliLeft OnlyDesktop lH20 mL5 mR20">
                Agroideas S.A.
                <br />
                Rivadavia 87, Ramona, Santa Fe
            </div>

            <website
                url-to-link="https://www.agroideassa.com.ar/"
                class="mR20 mL5"
            />
            <instagram
                url-to-link="https://www.instagram.com/agroideas_s.a/"
                class=""
            />

            <img
                src="../assets/logo-maiz-plus.png"
                alt="LogoMaizPlus"
                class="LogoMaizPlus"
            />

            <!-- <img src="../assets/logo-agroideas.png" alt="LogoAgroideas" class="LogoAgroideas aliCenter vAliMid"> -->
        </div>
    </div>
</template>

<script>
import Clases from "../Auxiliares/Clases.js";
import GUILink from "./GUILink.vue";
import { Herramientas } from "../Auxiliares/Enums";

export default {
    name: "GUI",
    components: {
        GUILink,
    },
    data() {
        return {
            Herramientas,
            SeccionProductoresVisible: false,
            startY: 0,
            scrollDirection: Clases.ScrollDirection.Down,
            UserLogueado() {
                if (this.$parent.Datos._User) {
                    return true;
                }
                return false;
            },
        };
    },
    created() {
        window.addEventListener("scroll", this.handleScroll);
    },
    mounted() {
        if (this.$parent.Datos._User == null) {
            return;
        }
        this.ValidarInfo();
        this.ChequearConexion();
    },
    methods: {
        handleScroll() {
            if (window.scrollY > this.startY) {
                this.scrollDirection = Clases.ScrollDirection.Up;
            } else {
                this.scrollDirection = Clases.ScrollDirection.Down;
            }

            this.startY = window.scrollY;
            if (this.startY < 110)
                this.scrollDirection = Clases.ScrollDirection.Down;

            if (
                window.innerHeight + window.pageYOffset >=
                document.body.offsetHeight
            )
                this.scrollDirection = Clases.ScrollDirection.Down;
        },
        FooterClass() {
            return (
                "ContenedorNav " +
                (this.scrollDirection == Clases.ScrollDirection.Up
                    ? "hideFooter"
                    : "")
            );
        },
        Desloguear() {
            this.ClickMenu();
            this.$parent.Datos.LogOff(this.$router);
        },
        ClickMenu() {
            if (this.$refs.Menu.classList.contains("MenuVisible")) {
                this.$refs.Menu.classList.remove("MenuVisible");
            } else {
                this.$refs.Menu.classList.add("MenuVisible");
            }
        },
        ChequearConexion() {
            try {
                var _El = this.$refs.DivSinConexion;
                if (_El) {
                    if (this.$parent.Datos.AppOnline()) {
                        if (_El.classList.contains("Visible")) {
                            _El.classList.remove("Visible");
                        }
                    } else {
                        if (_El.classList.contains("Visible") == false) {
                            _El.classList.add("Visible");
                        }
                    }
                }
                //var _This = this;
                setTimeout(() => {
                    this.ChequearConexion();
                }, 1000);
            } catch (error) {
                console.log(error);
            }
        },
        ClaseSinConexion() {},
        ValidarInfo() {
            if (this.$parent.Datos._User != null) {
                if (this.$parent.Datos._User._RolUsuario == 99) {
                    this.SeccionProductoresVisible = true;
                } else {
                    this.SeccionProductoresVisible = false;
                }
            }
        },
        NombreUsuario() {
            if (this.$parent.Datos._User != null) {
                return this.$parent.Datos._User._Nick;
            }
            return "...";
        },
        GoBack() {
            //console.log(this.$router);
            this.$router.back();
            //this.$router.go(-1);
        },
    },
};

window.onhashchange = function () {
    alert("adas");
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../Css/AgroIdeas.scss";
// $AgroIdeas: #004867;

/*#region Scrollbar*/
::-webkit-scrollbar {
    width: 5px;
}
::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0.2);
    // -webkit-box-shadow: inset 0 0 1px black;
    border-radius: 5px;
}
::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 5px;
    // -webkit-box-shadow: inset 0 0 16px black;
}
/*#endregion */

#herramientas {
    max-height: 360px;
    overflow-y: scroll;
}
.DivSinConexion {
    position: absolute;
    left: 0px;
    color: #fff;
    background: rgba(255, 10, 10, 1);
    box-sizing: border-box;
    // border-top:1px solid #000;
    // border-bottom:1px solid #000;
    box-shadow: inset 0 0 1px #000;
    width: 100%;
    line-height: 13px;
    text-align: center;
    opacity: 1;
    -webkit-transition: all 0.1s linear;
    -moz-transition: all 0.1s linear;
    -o-transition: all 0.1s linear;
    transition: all 0.1s linear;
    font-size: 0.6rem;
    max-height: 0px;
    overflow: hidden;
    top: 0px;
    &.Visible {
        max-height: 13px !important;
        top: -12px;
    }
}
.AjusteTitulo1 {
    margin-top: 15px;
}
body {
    margin: 0px;
}
.ContenedorGUI {
    overflow: hidden;
    //width:100%;
    // display: flex;
    // align-items: center;
    // justify-items: center;
}
.IconoHeader {
    height: 34px;
    width: 34px;
    padding: 5px;
    margin: 3px;
    border-radius: 100%;
    // border:1px solid white;
    box-shadow: 0 0 0px rgba(255, 255, 255, 0.5);
    cursor: pointer;
}
.IconoHeader1 {
    height: 35px;
    width: 42px;
    // padding:5px;
    margin: 7px;
    border-radius: 100%;
    // border:1px solid white;
    // box-shadow: 0 0 3px rgba(255,255,255,0.5);
    cursor: pointer;
}
.IcoCerrarMenu {
    position: absolute;
    right: 0px;
    top: 0px;
}
.ContenedorHeader {
    z-index: 10;
    position: fixed;
    top: 0px;
    left: 0px;
    height: 50px;
    line-height: 50px;
    width: 100vw;
    display: block;
    background-color: $AgroIdeas;
    box-shadow: 0 0px 10px #000;
    // max-width:800px;
}
.ContenedorNav {
    z-index: 10;
    position: fixed;
    bottom: 0px;
    left: 0px;
    height: 50px;
    line-height: 50px;
    width: 100%;
    display: block;
    background-color: $AgroIdeas;
    box-shadow: 0 0px 10px #000;
    color: white;
    font-size: 0.7em;
    line-height: 15px;
    transition: all 0.2s ease;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.LogoAgroideas {
    height: 40px;
}
.LogoMaizPlus {
    height: 50px;
    position: absolute;
    top: 0;
    right: 5px;
}
.Menu {
    box-sizing: content-box;
    z-index: 11;
    position: fixed;
    right: -100%;
    top: 0;
    min-height: 100%;
    width: 80%;
    // min-width:300px;
    max-width: 300px;
    // padding:0 5px;
    // background-color: rgba(0,0,0,0.95);
    background-color: $AgroIdeas;
    color: white;
    -webkit-transition: all 0.1s linear;
    -moz-transition: all 0.1s linear;
    -o-transition: all 0.1s linear;
    transition: all 0.1s linear;
    box-shadow: 0 0px 10px #000000;
}
.MenuVisible {
    right: 0% !important;
}
#BotonMenu {
    z-index: 12;
}

@media (min-width: 800px) {
    // desktop
    .LogoAgroideas {
        height: 60px;
    }
    .ContenedorHeader {
        height: 60px;
        line-height: 60px;
    }
    .IconoHeader {
        padding: 10px;
    }
    .IconoHeader1 {
        margin: 12px;
    }
    .ContenedorNav {
        position: relative;
        font-size: 0.9em;
    }
}

@media (max-width: 799px) {
    // mobile
    .hideFooter {
        bottom: -50px;
    }
}
</style>
